import React from 'react';
import {
  Document,
  PDFViewer,
  Page as PDFPage,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';

const styles = {
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  sponsorHeading: {
    fontSize: 14,
    fontWeight: 'bold',
    marginVertical: 10
  },
  contentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 5,
    textAlign: 'center'
  },
  columnNumberContent: {
    width: '15%',
    padding: 5,
    textAlign: 'right'
  }

};
const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const groupBySponsor = (data) => {
  return data.reduce((acc, item) => {
    const sponsorName = item.opd.sponsor.name;
    if (!acc[sponsorName]) {
      acc[sponsorName] = {
        patients: [],
        totalNetAmount: 0
      };
    }
    acc[sponsorName].patients.push(item);
    acc[sponsorName].totalNetAmount += item.opd.total;
    return acc;
  }, {});
};

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const SponsorWiseOpdReportPdf = ({ data }) => {
  const groupedData = groupBySponsor(data);

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Sponsor Wise OPD Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            {Object.keys(groupedData).map((sponsorName) => (
              <View key={sponsorName}>
                <Text style={styles.sponsorHeading} content={`Sponsor: ${sponsorName}`} />
                <Text
                  style={{ fontSize: '8px' }}
                  content={`Total Net Amount: ${groupedData[sponsorName].totalNetAmount.toFixed(2)}`}
                />
                <View style={styles.row}>
                  <Text style={{...styles.columnHeader, width: '8%'}} content="Sr." />
                  <Text style={styles.columnHeader} content="OPD No." />
                  <Text style={styles.columnHeader} content="Patient Name" />
                  <Text style={styles.columnHeader} content="Age" />
                  <Text style={styles.columnHeader} content="Gender" />
                  <Text style={styles.columnHeader} content="Opd Type" />
                  <Text style={styles.columnHeader} content="Doctor" />
                  <Text style={styles.columnHeader} content="Net Amount" />
                </View>
                {groupedData[sponsorName].patients.map((item, index) => (
                  <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                    <Text style={{...styles.columnContent, width: '8%'}} content={index + 1} />
                    <Text style={styles.columnContent} content={item.opd.op_no} />
                    <Text style={{...styles.columnContent, textAlign:'left'}}
                      content={`${item.opd.name_suffix} ${item.opd.first_name} ${item.opd.last_name}`} />
                    <Text  style={styles.columnContent}
                      content={new Date().getFullYear() - new Date(item.opd.dob).getFullYear()} />
                    <Text style={styles.columnContent} content={item.opd.gender} />
                    <Text style={styles.columnContent} content={item.opd.opd_type.type} />
                    <Text style={styles.columnContent} content={item.opd.consultant.name} />
                    <Text style={{...styles.columnNumberContent, width:'13%', marginRight:'15px'}} content={item.opd?.total?.toFixed(2)} />
                  </View>
                ))}
              </View>
            ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default SponsorWiseOpdReportPdf;
